// extracted by mini-css-extract-plugin
export default {"content":"SocietyAdminOrders_content__-lRZ9","realContent":"SocietyAdminOrders_realContent__MUZQ1"};